import React from "react";
import { PrimaryText, SecondaryText } from "../../styles/global";
import LinkIcon from "@mui/icons-material/Link";
import { ULContainer } from "../experience/style";

const ProjectCard = ({  name, image, tech, desc, link }) => {
  return (
    <div className=" card-shadow border rounded-lg" >
      <div className="  md:min-h-[5rem] border-b-2 rounded-lg">
        <img src={image}  className="rounded-lg h-[23rem] md:h-[20rem]  w-full" alt={name}/>
      </div>

      <div className=" p-4">
        <PrimaryText className="text-center">{name}</PrimaryText>
        <div className="mt-4 flex  justify-between">
          <div>
            <SecondaryText bg={"#ff5757"} className="w-3/4">Tech Used:</SecondaryText>
            <SecondaryText  className="">{tech}</SecondaryText>
          </div>
          <a href={link} target="_blank" rel="noreferrer">
            <LinkIcon className="text-white hover:text-[#ff5757]" />
          </a>
        </div>
        <div className="mt-3">
          <SecondaryText bg={"#ff5757"} className="">Description:</SecondaryText>
            <ULContainer>
                {desc.map((val, i) => {
                  return (
                    <li key={i} className="text-sm p-[0.2rem] mt-1">
                      • {val}
                    </li>
                  );
                })}
              </ULContainer>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
